import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, Row, Col, Button, Table, Card } from 'react-bootstrap';
import Select from 'react-select';
import { BASE_URL } from '../../services/Api';
import { authHeader } from '../../services/auth-header';
import { debounce } from 'lodash';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const ProductionOrderCreate = () => {
  const navigate = useNavigate();
  const [jobnumber, setjobnumber] = useState('');
  const [partno, setpartno] = useState('');

  const [customerOptions, setCustomerOptions] = useState([]);
  const [staffOptions, setStaffOptions] = useState([]);
  const [billOfMaterialOptions, setBillOfMaterialOptions] = useState([]);
  const [customerSearch, setCustomerSearch] = useState(encodeURIComponent(" "));
  const [staffSearch, setStaffSearch] = useState(encodeURIComponent(" "));
  const [billOfMaterialSearch, setBillOfMaterialSearch] = useState(encodeURIComponent(" "));
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState([]);
  const [selectedBillOfMaterial, setSelectedBillOfMaterial] = useState(null);
  const [productionorderdate, setProductionOrderDate] = useState(new Date().toISOString().split('T')[0]);
  const [inhousestartdate, setInhouseStartDate] = useState('');
  const [inhouseenddate, setInhouseEndDate] = useState('');
  const [outwardjobworkdate, setOutwardJobworkDate] = useState('');
  const [inwardjobworkdate, setInwardJobworkDate] = useState('');
  const [status, setProdOrderStatus] = useState('Open');
  const [tableRows, setTableRows] = useState([]);

  // ✅ For image upload
  const [createdOrderId, setCreatedOrderId] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]);

  const getCustomerData = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}customer/page/0/10/asc/id/${customerSearch}`,
        { headers: authHeader() }
      );
      const customers = response.data.Index || response.data.data;
      setCustomerOptions(
        customers.map((customer) => ({
          value: customer.id,
          label: customer.companyname,
        }))
      );
    } catch (error) {
      console.error('Error fetching customer data', error);
    }
  };

  const getStaffData = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}staff/page/0/10/asc/id/${staffSearch}`,
        { headers: authHeader() }
      );
      const staffMembers = response.data.Index || response.data.data;
      setStaffOptions(
        staffMembers.map((staff) => ({
          value: staff.id,
          label: `${staff.firstname} ${staff.lastname}`,
        }))
      );
    } catch (error) {
      console.error('Error fetching staff data', error);
    }
  };

  const getBillOfMaterialData = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}bom/page/bombytype/0/10/asc/id/pump/${billOfMaterialSearch}`,
        { headers: authHeader() }
      );
      const billOfMaterials = response.data.Index || response.data.data;
      setBillOfMaterialOptions(
        billOfMaterials.map((bom) => ({
          value: bom.id,
          label: bom.bomname,
          finalproduct: bom.finalproduct,
          grandtotalpump: bom.grandtotalpump,
          setjobnumber: bom.jobnumber,
          setpartno: bom.partno,


        }))
      );
    } catch (error) {
      console.error('Error fetching BOM data', error);
    }
  };

  useEffect(() => {
    getCustomerData();
    getStaffData();
    getBillOfMaterialData();
  }, [customerSearch, staffSearch, billOfMaterialSearch]);

  const handleSearchChangeCustomer = debounce((inputValue) => {
    setCustomerSearch(inputValue);
  }, 200);

  const handleSearchChangeStaff = debounce((inputValue) => {
    setStaffSearch(inputValue);
  }, 200);

  const handleSearchChangeBillOfMaterial = debounce((inputValue) => {
    setBillOfMaterialSearch(inputValue);
  }, 200);

  const handleBillOfMaterialSelect = (selectedOption) => {
    setSelectedBillOfMaterial(selectedOption);
    setjobnumber(selectedOption.setjobnumber || '');
    setpartno(selectedOption.setpartno || '');

    setTableRows([
      {
        billOfMaterial: selectedOption,
        remarks: '',
        quantity: 0,
        uom: '',
        finalproduct: selectedOption.finalproduct,
        grandtotalpump: selectedOption.grandtotalpump,
      },
    ]);
    setSelectedBillOfMaterial(selectedOption);
  };

  const handleInputChange = (index, field, value) => {
    const updatedRows = [...tableRows];
    updatedRows[index][field] = value;
    setTableRows(updatedRows);
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setSelectedImages(files);
  };



  // ✅ Production Order Submit
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!selectedCustomer || !selectedBillOfMaterial || !inhousestartdate) {
      alert("Please fill in all required fields.");
      return;
    }

    const Payload = {
      type: "Pump",
      status: status,
      customer: {
        id: selectedCustomer.value
      },
      operator: selectedStaff.map(staff => ({ id: staff.value })),
      popumpitems: tableRows.map(row => ({
        bomproductname: row.billOfMaterial?.label || '',
        quantity: row.quantity,
        uom: row.uom,
        ramarks: row.remarks,
        rate: Number(row.grandtotalpump),
        finishedbom: {
          id: selectedBillOfMaterial.value
        },
        product: {
          id: selectedBillOfMaterial.finalproduct
        }
      })),
      jobnumber,
      partno,
      productionorderdate,
      inhousestartdate,
      inhouseenddate,
      outwardjobworkdate,
      inwardjobworkdate
    };

    try {
      const response = await axios.post(
        `${BASE_URL}productionorder`,
        Payload,
        {
          headers: authHeader()
        }
      );
      setCreatedOrderId(response.data.id);

      Swal.fire({
        icon: 'success',
        title: 'Production Order Created Successfully!',
        html: `
          <p>Now you can upload images for this production order.</p>
          <p>If you don't want to upload images, you can go back to the production order list.</p>
        `,
        showCancelButton: true,
        confirmButtonText: 'Upload Images',
        cancelButtonText: 'Back to List',
      }).then((result) => {
        if (result.isDismissed) {
          // navigate("/Porderindex/1");
        }
      });

    } catch (error) {
      console.error("Error submitting data", error);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Failed to submit data.',
      });
    }
  };


  const handleImageUpload = async () => {
    if (!createdOrderId) {
      Swal.fire("Please submit the production order first.");
      return;
    }

    if (selectedImages.length === 0) {
      Swal.fire("Please select images to upload.");
      return;
    }

    const formData = new FormData();
    for (let i = 0; i < selectedImages.length; i++) {
      formData.append("files", selectedImages[i]);
    }

    try {
      const response = await axios.post(
        `${BASE_URL}productionorder/productionorders/images/${createdOrderId}`,
        formData,
        {
          headers: {
            ...authHeader(),
            'Content-Type': 'multipart/form-data',
          }
        }
      );

      console.log('Upload response:', response);
      Swal.fire("Success", "Images uploaded successfully!", "success");
      navigate("/Porderindex/1");

    } catch (error) {
      console.error("Image upload error", error);

      if (error.response?.status === 413) {
        Swal.fire(
          "Error",
          "Total file size exceeds the 10MB limit. Please upload smaller files.",
          "error"
        );
      } else {
        const errorMessage =
          error.response?.data?.message || "Image upload failed.";
        Swal.fire("Error", errorMessage, "error");
      }
    }
  };


  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>PRODUCTION ORDER</h6>
          <Link to="/Porderindex/1">
            <button className="button-70">BACK</button>
          </Link>
        </Card.Header>
        <div className="container">
          <br />
          <Form onSubmit={handleSubmit}>
            <Row>
               <Col md="6">
                <Form.Group>
                  <Form.Label>Part Number</Form.Label>
                  <Form.Control
                    type="text"
                    value={partno}
                    readOnly
                    disabled
                  // onChange={(e) => setjobnumber(e.target.value)}
                  />
                </Form.Group>
              </Col>
               <Col md="6">
                <Form.Group>
                  <Form.Label>Job Number</Form.Label>
                  <Form.Control
                    type="text"
                    value={jobnumber}
                    readOnly
                  // onChange={(e) => setjobnumber(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Production Order Status</Form.Label>
                  <Form.Select
                    value={status}
                    onChange={(e) => setProdOrderStatus(e.target.value)}
                  >
                    <option value="Open">Open</option>
                    <option value="Ongoing">Ongoing</option>
                    <option value="On Hold">On Hold</option>
                    <option value="Complete">Complete</option>
                  </Form.Select>
                </Form.Group>
              </Col>
             
              <Col md="6">
                <Form.Group>
                  <Form.Label>Production Order Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={productionorderdate}
                    onChange={(e) => setProductionOrderDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Customer Name</Form.Label>
                  <Select
                    options={customerOptions}
                    onChange={setSelectedCustomer}
                    onInputChange={handleSearchChangeCustomer}
                    value={selectedCustomer}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Operator Name</Form.Label>
                  <Select
                    isMulti
                    options={staffOptions}
                    onChange={setSelectedStaff}
                    onInputChange={handleSearchChangeStaff}
                    value={selectedStaff}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Inhouse Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={inhousestartdate}
                    onChange={(e) => setInhouseStartDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Inhouse End Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={inhouseenddate}
                    onChange={(e) => setInhouseEndDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Outward (Jobwork) Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={outwardjobworkdate}
                    onChange={(e) => setOutwardJobworkDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Inward (Jobwork) Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={inwardjobworkdate}
                    onChange={(e) => setInwardJobworkDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <br />
            <hr />
            <Row>
              <Col md="12">
                <Form.Group>
                  <Form.Label>Finished Product Name</Form.Label>
                  <Select
                    options={billOfMaterialOptions}
                    onChange={handleBillOfMaterialSelect}
                    onInputChange={handleSearchChangeBillOfMaterial}
                    value={selectedBillOfMaterial}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <br /><br />
            <div className="table-responsive">
              <Table>
                <thead>
                  <tr>
                    <th>Product Details</th>
                    <th>Quantity</th>
                    <th>Unit of Measure (UOM)</th>
                    <th>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {tableRows.map((row, index) => (
                    <tr key={index}>
                      <td>{row.billOfMaterial ? row.billOfMaterial.label : ''}</td>
                      <td>
                        <Form.Control
                          className="quantity"
                          type="number"
                          value={row.quantity}
                          onChange={(e) =>
                            handleInputChange(index, 'quantity', parseInt(e.target.value, 10))
                          }
                        />
                      </td>
                      <td>
                        <Form.Select
                          className="uom"
                          value={row.uom}
                          onChange={(e) =>
                            handleInputChange(index, 'uom', e.target.value)
                          }
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: base => ({ ...base, zIndex: 9999 })
                          }}
                        >
                          <option>Select uom</option>
                          <option value="bot">Bot</option>
                          <option value="ctn">Ctn</option>
                          <option value="days">Days</option>
                          <option value="ft">Ft</option>
                          <option value="hrs">Hrs</option>
                          <option value="kg">Kg</option>
                          <option value="grams">Grams</option>
                          <option value="ltr">Ltr</option>
                          <option value="mtr">Mtr</option>
                          <option value="nos">Nos</option>
                          <option value="pil">Pil</option>
                          <option value="pkt">Pkt</option>
                          <option value="set">Set</option>
                          <option value="pcs">Pcs</option>
                        </Form.Select>
                      </td>
                      <td>
                        <textarea
                          rows="2"
                          cols="30"
                          className="custom-textarea"
                          value={row.remarks}
                          onChange={(e) => handleInputChange(index, 'remarks', e.target.value)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <br />
            <Button type="submit" variant="primary">Submit</Button>
          </Form>

          {/* ✅ Image Upload Section (After submit only) */}
          {createdOrderId && (
            <div className="mt-4">
              <h5>Step 2: Upload Production Order Images</h5>
              <p className="text-muted">
                Upload images for this production order or{' '}
                <Link to="/Porderindex/1" className="text-primary">
                  go back to production order list
                </Link>
              </p>
              <Form.Group controlId="formFileMultiple" className="mb-3">
                <Form.Label>Upload Images</Form.Label>
                <Form.Control
                  type="file"
                  multiple
                  onChange={handleImageChange}
                  accept="image/*"
                />
              </Form.Group>
              <div className="d-flex gap-2">
                <Button variant="success" onClick={handleImageUpload}>
                  Upload Images
                </Button>
                <Button
                  variant="secondary"
                  onClick={() => navigate("/Porderindex/1")}
                >
                  Skip and Go Back
                </Button>
              </div>
            </div>
          )}
        </div>
      </Card>
    </div>
  );
};

export default ProductionOrderCreate;